var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0",attrs:{"grid-list-lg":""}},[_c(_setup.ChangesDetection,{ref:"changesDetection",attrs:{"value":_vm.userInput},on:{"change":function($event){return _setup.onChange()}}},[_c('v-layout',{attrs:{"wrap":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }